let bootstrap_popovers = require( 'bootstrap/js/dist/popover' );

let popovers = function( $ ) {

	let init = function() {
		let $popovers = $( 'html body' ).find( '[data-toggle="popover"]' ).not( '.setup-popover' );

		$popovers.popover();

		$popovers.on( 'click', ( e ) => {
			e.preventDefault();
		} );

		$popovers.addClass( '.setup-popover' );
	};

	$( document ).ready( init );

	return {
		init: init
	}

} ( jQuery );

module.exports = popovers;